/**
 * Compare two filter objects regardless of key order.
 * Filters out undefined and empty string values before comparison.
 */
export const areFiltersEqual = (
  filters1: Record<string, unknown>,
  filters2: Record<string, unknown>,
): boolean => {
  const keys1 = Object.keys(filters1).filter(
    (k) => filters1[k] !== undefined && filters1[k] !== '',
  );
  const keys2 = Object.keys(filters2).filter(
    (k) => filters2[k] !== undefined && filters2[k] !== '',
  );

  if (keys1.length !== keys2.length) return false;

  const sortedKeys1 = [...keys1].sort();
  const sortedKeys2 = [...keys2].sort();

  if (sortedKeys1.join(',') !== sortedKeys2.join(',')) return false;

  return sortedKeys1.every((key) => filters1[key] === filters2[key]);
};
